import { Field } from "@progress/kendo-react-form";
import { FormRegion } from "../../../../components/formregion";
import {
  FormDropDownList,
  FormDropDownListById,
  FormInput,
  FormTextArea,
} from "../../../../forms/form-components";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { showHideGoogleSheets } from "../../../../redux/slices/importschedulepageslice";
import { useEffect } from "react";

const GeneralStep = (props) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const pageState = useSelector((state) => state.importSchedulePage);
  const allowedTypes = [2, 4, 5];

  const listOfIdentityColumn = pageState.currentDataset.Fields.filter((field) =>
    allowedTypes.includes(field.DataTypeId),
  );
  
  const listOfFiles =
    pageState.formValues.GoogleList?.filter((f) => f.IsSheet) ?? [];

  const ddlType = [
    { Id: 0, Title: t("schedule.select") },
    //{ Id: 1, Title: "Pdf" },
    { Id: 2, Title: t("schedule.excel") },
  ];

  const ddlSource = [
    { Id: 0, Title: t("schedule.select") },
    { Id: 1, Title: t("schedule.google_sheets") },
    // { Id: 2, Title: "Https" },
    // { Id: 3, Title: "SFTP" },
    // { Id: 4, Title: "Email" },
  ];

  useEffect(() => {
    const source = pageState.formValues.Source;
    dispatch(showHideGoogleSheets(source === 1 || source === "1"));
    if (source === 1 || source === "1") {
      props.loadGoogleConnections(t);
    }
  }, [pageState.formValues.Source]);

  useEffect(() => {
    if (pageState.formValues.ConnectionId) {
      props.loadGoogleConnectorSheets(t);
    }
  }, [pageState.formValues.ConnectionId]);

  useEffect(() => {
    if (pageState.formValues.SheetName) {
      props.getGoogleSheetId(
        pageState.formValues.File,
        pageState.formValues.SheetName,
        pageState.formValues.FilePath,
        pageState.formValues.ConnectionId,
        t,
      );
    }
  }, [pageState.formValues.SheetName]);

  return (
    <FormRegion>
      <div className="form-group form-group-1 stepper-rd-btns">
        <div className="dataset-info">
          <Field
            id={"Name"}
            name={"Name"}
            label={t("schedule.name")}
            component={FormInput}
            maxLength={255}
            onChange={(e) =>
              props.onChangeFormValue("Name", e.value, props.onChange)
            }
          />
          <Field
            id={"Description"}
            name={"Description"}
            label={t("schedule.description")}
            component={FormTextArea}
            style={{ height: 80 }}
            onChange={(e) =>
              props.onChangeFormValue("Description", e.value, props.onChange)
            }
          />

          <Field
            id={"Type"}
            name={"Type"}
            label={t("schedule.type")}
            component={FormDropDownListById}
            data={ddlType}
            dataItemKey="Id"
            textField="Title"
            value={pageState.formValues.Type}
            onChange={(e) =>
              props.onChangeFormValue("Type", e.value, props.onChange)
            }
          />

          <Field
            id={"Source"}
            name={"Source"}
            label={t("schedule.source")}
            component={FormDropDownListById}
            data={ddlSource}
            dataItemKey="Id"
            textField="Title"
            value={pageState.formValues.Source}
            onChange={(e) => {
              props.onChangeFormValue("Source", e.value, props.onChange);
              props.onChangeFormValue("File", "", props.onChange);
            }}
          />

          {pageState.formValues.ShowGoogleSheets && (
            <>
              <Field
                id={"Connections"}
                name={"Connections"}
                label={t("connection.connection")}
                component={FormDropDownListById}
                data={pageState.formValues.Connections}
                dataItemKey="ConnectionId"
                textField="ConnectionTitle"
                value={pageState.formValues.ConnectionId}
                onChange={(e) => {
                  props.onChangeFormValue(
                    "ConnectionId",
                    e.value,
                    props.onChange,
                  );
                }}
              />
            </>
          )}

          {pageState.formValues.ConnectionId && (
            <>
              <Field
                id={"File"}
                name={"File"}
                label={t("schedule.file")}
                component={FormDropDownListById}
                data={listOfFiles}
                dataItemKey="SheetId"
                textField="FilePath"
                value={pageState.formValues.File}
                onChange={(e) => {
                  const file = listOfFiles.find((f) => f.SheetId == e.value);
                  props.onChangeFormValue("File", e.value, props.onChange);
                  props.onChangeFormValue("SheetId", e.value, props.onChange);
                  props.onChangeFormValue(
                    "FilePath",
                    file.FilePath,
                    props.onChange,
                  );
                  props.onChangeFormValue("SheetName", "", props.onChange);
                }}
              />
            </>
          )}

          {pageState.formValues.File && (
            <Field
              id="SheetName"
              name="SheetName"
              label={t("schedule.sheetname")}
              component={FormDropDownList}
              data={
                pageState.formValues.GoogleList?.find(
                  (e) => e.SheetId === pageState.formValues.File,
                )?.SheetNames || []
              }
              value={pageState.formValues.SheetName}
              onChange={(e) =>
                props.onChangeFormValue("SheetName", e.value, props.onChange)
              }
            />
          )}

          {pageState.formValues.datasetId && pageState.currentDataset && (
            <Field
              id={"IdentityColumnId"}
              name={"IdentityColumnId"}
              label={t("schedule.IdentityColumn")}
              component={FormDropDownListById}
              data={listOfIdentityColumn}
              dataItemKey="Id"
              textField="Name"
              value={pageState.formValues.IdentityColumnId}
              onChange={(e) => {
                const selectedField = listOfIdentityColumn.find(
                  (f) => f.Id === e.value,
                );
                props.onChangeFormValue(
                  "IdentityColumn",
                  selectedField?.Title || null,
                  props.onChange,
                );
                props.onChangeFormValue(
                  "IdentityColumnId",
                  e.value,
                  props.onChange,
                );
              }}
            />
          )}
        </div>
      </div>
    </FormRegion>
  );
};

export default GeneralStep;
